/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S4_Li3Inputs */

const en_guide_json_schema_s4_li3 = /** @type {(inputs: Guide_Json_Schema_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Documentation</strong>: OpenAPI (Swagger) uses JSON Schema to describe API data models`)
};

const ko_guide_json_schema_s4_li3 = /** @type {(inputs: Guide_Json_Schema_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>문서화</strong>: OpenAPI (Swagger)가 JSON Schema를 사용하여 API 데이터 모델을 설명`)
};

const ja_guide_json_schema_s4_li3 = /** @type {(inputs: Guide_Json_Schema_S4_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>ドキュメンテーション</strong>: OpenAPI（Swagger）はJSON Schemaを使用してAPIデータモデルを記述`)
};

/**
* | output |
* | --- |
* | "<strong>Documentation</strong>: OpenAPI (Swagger) uses JSON Schema to describe API data models" |
*
* @param {Guide_Json_Schema_S4_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s4_li3 = /** @type {((inputs?: Guide_Json_Schema_S4_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S4_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s4_li3(inputs)
	if (locale === "ko") return ko_guide_json_schema_s4_li3(inputs)
	return ja_guide_json_schema_s4_li3(inputs)
});